import * as R from 'ramda';
import axios from 'axios';
import {v1 as uuid} from "uuid";
import ErrorHandler from './../../Service/ApiErrorHandle';

function CustomException(error) {
  return {
    endpoint: R.pathOr('', ['response', 'config', 'url'], error),
    statusText: R.pathOr('', ['response', 'statusText'], error),
    message: R.pathOr('', ['message'], error),
    status: R.pathOr(500, ['response', 'status'], error),
    data: R.pathOr(null, ['response', 'data'], error),
  };
}


const webAppBaseUrl = process.env.REACT_APP_WEBAPP_API_BASE_URL

const contentType ='application/json'



// changes ${assetApiUrl}${apiVersion}
const postAsset = (endpoint, payload, headers, options = {}) => {
  return post(`${webAppBaseUrl}${endpoint}`, payload, headers, options);
};
// changes ${orderApiUrl}${apiVersion}
const postOrder = (endpoint, payload, headers, options = {}) => {
  return post(`${webAppBaseUrl}${endpoint}`, payload, headers, options);
};

// changes ${userApiUrl}${apiVersion}
const postUser = (endpoint, payload, headers, options = {}) => {
  return post(`${webAppBaseUrl}${endpoint}`, payload, headers, options);
};

//change ${fleetApiUrl}${apiVersion}${endpoint}
const postFleet = (endpoint, payload, headers, options = {}) => {
  return post(`${webAppBaseUrl}${endpoint}`, payload, headers, options);
};

//Change `${organizationApiUrl}${apiVersion}${endpoint} `
const postOrganization = (endpoint, payload, headers, options = {}) => {
  return post(`${webAppBaseUrl}${endpoint}`, payload, headers, options);
};

//Change `${userApiUrl}${apiVersion}${endpoint}`
const postRoles = (endpoint, payload, headers, options = {}) => {
  return post(`${webAppBaseUrl}${endpoint}`, payload, headers, options);
};

// changes ${notificationApiUrl}${apiVersion}
const postNotification = (endpoint, payload, headers, options = {}) => post(`${webAppBaseUrl}${endpoint}`, payload, headers, options);



const post = (endpoint, payload, headers, options = {}) => {
  const commonHeaders = {
    'Content-Type': contentType,
    'Access-Control-Allow-Origin': webAppBaseUrl,
    'x-correlation-id': uuid(),
  };

  const commonGetOptions = {
    method: 'POST',
    responseType: 'json',
    ...options,
  };
  return axios.post(endpoint,
  payload,
    {
      ...commonGetOptions,
      headers: { ...commonHeaders, ...headers },
    })
    .then(response => response.data)
    .catch((error) => {
      ErrorHandler.SetCommonApiHandle(error);
      throw new CustomException(error);
    });
};



function exportFunctions() {
  
   
    const callAssetPost = postAsset;
    
    const callOrderPost = postOrder;
    
    const callUserPost = postUser;
    
    const callFleetPost = postFleet;
   
    
    const callRolesPost = postRoles;
    
    const callOrganizationPost = postOrganization;
    
    
    const callNotificationPost = postNotification;
    
    return {
      
      callAssetPost,   
      callOrderPost,
       
      callUserPost,
  
      
      callFleetPost,
    
      callRolesPost,     
      callOrganizationPost,        
      callNotificationPost,    
    };
  }
  export default exportFunctions();
